import React from "react";

import { styled, Theme, CSSObject } from "@mui/material/styles";
import Drawer, { DrawerProps } from "@mui/material/Drawer";

const drawerMixin = (theme: Theme, open: boolean): CSSObject => ({
  overflowX: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    ...(open
      ? {
          duration: theme.transitions.duration.enteringScreen,
        }
      : {
          duration: theme.transitions.duration.leavingScreen,
        }),
  }),
  ...(open
    ? {
        width: 270,
      }
    : {
        width: `calc(${theme.spacing(7)})`,
      }),
});

interface ICustomDrawer extends DrawerProps {
  open: boolean;
}

export const CustomDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})<ICustomDrawer>(({ theme, open }) => ({
  width: 270,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...{
    ...drawerMixin(theme, open),
    "& .MuiDrawer-paper": {
      ...drawerMixin(theme, open),
      backgroundColor: "#1D1D1D",
    },
  },
}));
